import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiObjectResponse } from '../../../../../common/models/api-response.model';
import { ReportResponseData } from '../../../../../common/models/report.model';
import { baseUrl } from '../../../../../common/constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class WorkflowReportsService {
  baseUrlPrefix = baseUrl;
  private readonly http = inject(HttpClient);

  getWorkflowReports(
    flow_template: string,
    chart: string,
    timezone: string,
    range?: string
  ) {
    let url = `${this.baseUrlPrefix}/application/flow-templates/${flow_template}/charts/${chart}?timezone=${timezone}`;
    if (range && range !== 'all') {
      url += `&range=${range}`;
    }
    return this.http.get<ApiObjectResponse<ReportResponseData>>(url);
  }
}
